import type { EntityRegistry } from '@sites/entity-migrator';

import {
    DefaultColumnEntitySchema,
    SpecificColumnEntitySchema,
    ZeroColumnEntitySchema,
    columnVariantFromContext,
    type ColumnEntity,
} from './schemas';

const BY_VARIANT = {
    default: DefaultColumnEntitySchema,
    specific: SpecificColumnEntitySchema,
    zero: ZeroColumnEntitySchema,
} as const;

export const columnRegistry: EntityRegistry<ColumnEntity> = {
    name: 'column',
    getEntitySchema: (entity: unknown, ctx) => {
        if (typeof entity !== 'object' || entity === null) return null;

        const { entitySubType, version, sectionId, widgets } = entity as {
            entitySubType?: unknown;
            version?: unknown;
            sectionId?: unknown;
            widgets?: unknown;
        };

        if (entitySubType === 'default') return DefaultColumnEntitySchema;
        if (entitySubType === 'specific') return SpecificColumnEntitySchema;
        if (entitySubType === 'zero') return ZeroColumnEntitySchema;

        // Pre-versioning columns carry neither subtype nor version, and unlike
        // sections not even the header ones tag themselves — the envelope is the
        // only proof this is a column at all, and the row it sits in the only
        // proof of which kind.
        if (entitySubType === undefined && version === undefined) {
            if (typeof sectionId !== 'string' || !Array.isArray(widgets)) return null;

            return BY_VARIANT[columnVariantFromContext(ctx)];
        }

        return null;
    },
};
